import VueI18n from 'vue-i18n'
import Vue from 'vue'
import EnTranslate from './en'
// import FrTranslate from './fr'

Vue.use(VueI18n)

const messages = {
  en: EnTranslate,
  // fr: FrTranslate
}

// Create VueI18n instance with options
const i18n = new VueI18n({
  locale: 'en', // set locale
  messages, // set locale messages
})

export default i18n



// WEBPACK FOOTER //
// ./src/translate/index.js